import { DetailsItem } from 'components/secondaryMarket/shared/SidePanel/DetailsItem';
import type { IntlKey } from 'locales';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch/productSearch.model';

type DetailsItemValueProps = {
  label: IntlKey;
  e2e: string;
  value: number | undefined;
  priceType: SecondaryPriceType;
  alreadyFormatted?: boolean;
  currency: string;
  children?: ReactNode;
};
export function DetailsItemValue({ label, e2e, value, priceType, currency, alreadyFormatted }: DetailsItemValueProps) {
  const { formatNumber } = useIntl();
  if (value === undefined) {
    return null;
  }
  const isPercent = priceType === 'Percent';
  return (
    <DetailsItem label={label} e2e={e2e}>
      {isPercent && (
        <>
          <span>
            {formatNumber(alreadyFormatted ? value : value * 100.0, {
              maximumFractionDigits: 4,
            })}
          </span>
          <span className="ms-1">%</span>
        </>
      )}
      {!isPercent && (
        <>
          <span>{formatNumber(value, { maximumFractionDigits: 4 })}</span>
          <span className="ms-1">{currency}</span>
        </>
      )}
    </DetailsItem>
  );
}
